import { get } from 'lodash';
import React from 'react';
import PowerBiReport from '../../PowerBiReport/PowerBiReport';
import './RichTextLibraryItemCard.scss';

const PowerBILibraryItemCard = ({
  libraryItem,
  setIsDragDisabled,
  innerRef,
  projectId,
  ...props
}) => {
  setIsDragDisabled(false);

  const parsedData = JSON.parse(libraryItem.data || '{}');
  const pageName =
    get(libraryItem, 'pageName', '') || get(parsedData, 'PageName', '');

  return (
    <div
      ref={innerRef}
      {...props}
      className="rich-text-library-item-edit powerbi-report-wrapper"
    >
      <PowerBiReport
        item={{
          ...libraryItem,
          reportId:
            (libraryItem && libraryItem.reportId) ||
            (parsedData && parsedData.ReportId),
          pageName,
        }}
        projectId={projectId}
      />
    </div>
  );
};

export default React.memo(PowerBILibraryItemCard);
